import { useField, useFormikContext } from 'formik';
import React from 'react';
import CustomPhoneInput from '../../pages/dynamicFormEngine/FormFields/CustomPhoneInput';
import PhoneInput, { parsePhoneNumber, isValidPhoneNumber as isValidNumber } from 'react-phone-number-input';
import * as Yup from 'yup';

const isValidPhoneNumber = (value, country) => {
  if (!value) return true;
  const phoneNumber = parsePhoneNumber(value);
  if (!phoneNumber || !isValidNumber(value)) return false;
  return country ? phoneNumber.country === country : true;
};

export const phoneValidationSchema = Yup.string()
  .test('isValidPhoneNumber', 'Please enter valid number', (value) => isValidPhoneNumber(value));

export const usPhoneValidationSchema = Yup.string()
  .test('isValidUsPhoneNumber', 'Please enter a valid US phone number', (value) =>
    isValidPhoneNumber(value, 'US')
  );

const Phone = ({ form, ...props }) => {
  const [field, meta] = useField(props.field.name);
  const formikContext = useFormikContext();
  const formik = form || formikContext;
  const isUsOnly = props.countries?.length === 1 && props.countries[0] === 'US';

  const handleKeyPress = (event) => {
    if (event.charCode === 32) {
      event.preventDefault();
    }
  };

  const handleChange = (value) => {
    if (!formik.touched[field.name]) {
      formik.setFieldTouched(field.name);
    }
    formik.setFieldValue(field.name, value || '');
  };

  if (isUsOnly) {
    const showError = Boolean((meta.touched || formik.submitCount > 0) && meta.error);

    return (
      <PhoneInput
        placeholder={props.placeholder}
        value={field.value}
        defaultCountry={props.defaultCountry ?? 'US'}
        countries={['US']}
        addInternationalOption={false}
        countrySelectProps={{ disabled: true }}
        size={props.size ? props.size : 'small'}
        onKeyPress={handleKeyPress}
        onChange={handleChange}
        onBlur={() => formik.setFieldTouched(field.name, true)}
        label={props?.label}
        name={field.name}
        touched={{ ...formik.touched, ...(showError ? { [field.name]: true } : {}) }}
        errors={formik.errors}
        inputComponent={CustomPhoneInput}
      />
    );
  }

  return (
    <PhoneInput
      {...formik}
      {...field}
      placeholder={props.placeholder}
      value={field.value}
      size={props.size ? props.size : 'small'}
      onKeyPress={handleKeyPress}
      onChange={handleChange}
      label={props?.label}
      inputComponent={CustomPhoneInput}
    />
  );
};

export default Phone;
